// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"181":"d4a0e9f4","236":"6f4de5cd","453":"668de03b","515":"c2cb2930","558":"ee53a44d","701":"fac046be","880":"0c6d16b1","903":"d16a82a5","919":"73515575"}[chunkId] + ".chunk.js";
};